// AdminFolders.js — CLAIM-FILES-1 Phase 5 (2026-06-24). Firm-wide management of the
// GLOBAL default folders that appear on every claim's Files tab. Add / rename / set PHI
// default / retire (retire blocked when a folder is in use or is core-workflow). Adjusters
// still add their own per-claim folders on top of these. Gated manage_bill_intake.
import { useState, useEffect } from "react";
import { apiFetch } from "../api";

export default function AdminFolders() {
  const [folders, setFolders] = useState([]);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState(null);
  const [editId, setEditId] = useState(null);
  const [editVal, setEditVal] = useState("");
  const [newName, setNewName] = useState("");

  const load = () => apiFetch("/admin/folders").then(d => setFolders(d || [])).catch(() => setFolders([]));
  useEffect(() => { load(); }, []);
  const act = async (fn) => { if (busy) return; setBusy(true); setMsg(null); try { await fn(); } catch (e) { setMsg(String(e.message || e).slice(0, 200)); } finally { setBusy(false); } };
  const add = () => { const n = newName.trim(); if (!n) return; act(async () => { await apiFetch("/admin/folders", { method: "POST", body: { name: n } }); setNewName(""); load(); }); };
  const saveName = (f) => { const v = editVal.trim(); setEditId(null); if (!v || v === f.name) return; act(async () => { await apiFetch(`/admin/folders/${f.id}`, { method: "PATCH", body: { name: v } }); load(); }); };
  const togglePhi = (f) => act(async () => { await apiFetch(`/admin/folders/${f.id}`, { method: "PATCH", body: { is_phi_default: !f.is_phi_default } }); load(); });
  const retire = (f) => { if (!window.confirm(`Retire the “${f.name}” folder firm-wide? It will stop appearing on claims.`)) return; act(async () => { await apiFetch(`/admin/folders/${f.id}`, { method: "DELETE" }); load(); }); };

  // top-level folders, each followed by its children (one level of nesting)
  const rows = [];
  folders.filter(f => !f.parent_id).forEach(t => {
    rows.push({ f: t, depth: 0 });
    folders.filter(c => c.parent_id === t.id).forEach(c => rows.push({ f: c, depth: 1 }));
  });

  return (<div>
    <div className="section-header"><span className="section-title">Document Folders</span></div>
    <p style={{ fontSize: 12.5, color: "var(--text2)", margin: "0 0 12px", maxWidth: 640 }}>
      These global folders appear on <strong>every</strong> claim's Files tab. Adjusters can add their own
      per-claim folders on top of these. Core-workflow folders (🔒) are filled automatically by the
      Bills / Payments / Invoices workflows and can't be retired. Double-click a name to rename it.
    </p>
    {msg && <div className="alert-error" style={{ marginBottom: 10 }}>{msg}</div>}
    <div className="card" style={{ marginBottom: 12 }}>
      <table><thead><tr>
        <th>Folder</th><th>PHI default</th><th className="text-right">In use</th><th></th>
      </tr></thead><tbody>
        {rows.map(({ f, depth }) => (<tr key={f.id}>
          <td style={{ paddingLeft: 10 + depth * 24 }}>
            <span style={{ marginRight: 6 }}>{f.is_core_workflow ? "🔒" : "📁"}</span>
            {editId === f.id
              ? <input autoFocus value={editVal} onFocus={e => e.target.select()} onChange={e => setEditVal(e.target.value)}
                       onBlur={() => saveName(f)} onKeyDown={e => { if (e.key === "Enter") saveName(f); else if (e.key === "Escape") setEditId(null); }}
                       style={{ fontSize: 13, padding: "1px 4px" }} />
              : <span onDoubleClick={() => { setEditId(f.id); setEditVal(f.name); }} title="Double-click to rename"
                      style={{ fontWeight: 500 }}>{f.name}</span>}
          </td>
          <td><label style={{ fontSize: 12, cursor: "pointer", userSelect: "none" }}>
            <input type="checkbox" checked={!!f.is_phi_default} onChange={() => togglePhi(f)} disabled={busy} /> PHI
          </label></td>
          <td className="text-right" style={{ fontSize: 12, color: "var(--text3)" }}>{f.doc_count || 0}</td>
          <td style={{ textAlign: "right", whiteSpace: "nowrap" }}>
            <button onClick={() => { setEditId(f.id); setEditVal(f.name); }} title="Rename"
                    style={{ background: "none", border: "none", cursor: "pointer", color: "var(--blue)", fontSize: 12, marginRight: 10 }}>Rename</button>
            {!f.is_core_workflow && <button onClick={() => retire(f)} disabled={busy} title="Retire firm-wide"
                    style={{ background: "none", border: "none", cursor: "pointer", color: "#dc2626", fontSize: 12 }}>Retire</button>}
          </td>
        </tr>))}
      </tbody></table>
    </div>
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <input value={newName} onChange={e => setNewName(e.target.value)} onKeyDown={e => { if (e.key === "Enter") add(); }}
             placeholder="New global folder name…" style={{ fontSize: 13, padding: "5px 8px", flex: 1, maxWidth: 320 }} />
      <button className="btn btn-blue btn-sm" onClick={add} disabled={busy || !newName.trim()}>+ Add folder</button>
    </div>
  </div>);
}
